module.exports = __webpack_public_path__ + "static/media/trial 1(3)-after-10-sek-if-correct.3eb7126b.mp3";